export const get_exchange_orders = `query get_exchange_orders($paginator: Paginator!, $order: ListingOrder!, $filter: ListingFilter!){
    get_exchange_orders(paginator: $paginator, order: $order, filter: $filter){
        exchange_orders{
            id
            transaction_code
            status
            direction
            security{
                short_name
                name
                stock_market_locality
                currency{
                    currency
                    name
                    decimal
                }
            }
            count
            fulfilled_count
            type
            limit_price
            activation_price
            validity_start
            validity_end
            deal_price
            reject_reason
            reject_reason_en
            cancel_accepted
            cancel_reject_reason
            cancel_reject_reason_en
        }
        page
        page_count
    }
}`;
